import { useCallback } from 'react';
import { useCheckout } from '~/features/checkout/hooks';
import { DeliveryMethod } from '../../../models/checkout';
import { getDroppointDeliveryAddress } from '../../DeliveryAddressMap/utils/selectedCarrierHasDeliveryAddress';
import { useCheckoutState } from '~/features/checkout/hooks/useCheckoutState';

export const useShippingAddress = () => {
    const { deliveryAddress } = useCheckout();
    const {
        isUsingAlternateAddress,
        billingAddress,
        deliveryMethod: deliveryMethodCheckout,
        carrier,
        vendorSelectedDroppoint,
    } = useCheckoutState();

    const getAddress = useCallback(
        (
            isAlternateShippingValid: boolean,
            alternateShippingAddress: any,
            deliveryMethodParsed?: DeliveryMethod,
        ) => {
            const deliveryMethod = deliveryMethodParsed || deliveryMethodCheckout;
            let shippingAddress: Record<string, unknown> | null = null;

            if (!deliveryAddress || !deliveryMethod) return false;
            if (!carrier) return false;

            if (deliveryMethod === 'dropPoint') {
                // do same changes here as it has been done in addressDelivery under this code
                if (vendorSelectedDroppoint) {
                    if (isAlternateShippingValid) {
                        shippingAddress = isUsingAlternateAddress
                            ? alternateShippingAddress
                            : deliveryAddress;
                    }
                } else {
                    if (!deliveryAddress) return;

                    shippingAddress = getDroppointDeliveryAddress(
                        carrier[deliveryMethod],
                        deliveryAddress,
                    );
                }
            }

            if (deliveryMethod === 'addressDelivery' || deliveryMethod === 'truckDelivery') {
                if (isAlternateShippingValid) {
                    shippingAddress = isUsingAlternateAddress
                        ? alternateShippingAddress
                        : deliveryAddress;
                }
            }

            if (deliveryMethod === 'clickAndCollect') {
                shippingAddress = deliveryAddress;
            }

            if (deliveryMethod === 'virtual') {
                // const [carrier] = carriers.virtual;
                // setCarrier(carrier);
                shippingAddress = billingAddress as Record<string, unknown>;
            }

            if (!shippingAddress) {
                return false;
            }

            return shippingAddress;
        },
        [deliveryAddress],
    );

    return {
        getAddress,
    };
};
